module.exports = __webpack_public_path__ + "img/CRW.84b589f2.svg";